import type { APIClientError } from '@/services/Http/ApiClientError';
import { useEffect, useState } from 'react';

export interface IDataFetchResult<T = any> {
    data?: T;
    error?: APIClientError;
}

export const useFetchResponseHandler = <T = any>(
    fetcher: () => Promise<T>,
    watchParams: Parameters<typeof useEffect>[1] = []
): IDataFetchResult<T> => {
    const [data, setData] = useState<T | undefined>(undefined); // undefined is un-fetched. not found would change this to null
    const [error, setError] = useState<APIClientError | null>(null);

    useEffect(() => {
        let didCancel = false;
        const fetch = async () => {
            try {
                const fetchedData = await fetcher();
                if (!didCancel) {
                    setData(fetchedData);
                }
            } catch (e) {
                if (!didCancel) {
                    setError(e);
                }
            }
        };
        setData(undefined);
        fetch();

        return () => {
            didCancel = true;
        };
    }, watchParams);

    return {
        data,
        error,
    };
};
